import { useQuery, UseQueryResult } from "@tanstack/react-query";
import axios from "axios";
import { enum_api_uri } from "../../../utils/enum";
import { useAuthStore } from "../../../../../console/store/useAuthStore";

export interface GetCustomerEventContentResponse {
    event_content_idx: number;
    depth1_idx: number;
    depth1: string;
    depth2: string | null;
    flag: boolean;
}
export const useGetCustomerEventContent = (customerId: number): UseQueryResult<GetCustomerEventContentResponse[], Error> => {
    const accessToken = useAuthStore(state => state.accessToken);
    return useQuery<GetCustomerEventContentResponse[], Error>({
        queryKey: ["getCustomerEventContent", customerId],
        queryFn: async () => {
            const response = await axios.get(`${enum_api_uri.get_customer_event_content.replace(":customer_idx", customerId.toString())}`, {
                headers: {
                    Authorization: `Bearer ${accessToken}`,
                },
            });
            return response.data.data;
        },
        placeholderData: prevData => {
            if (prevData) {
                return {
                    ...prevData,
                };
            }
            return undefined;
        },
    });
};
